export interface Article {
  id: string;
  title: string;
  slug: string;
  category: string;
  excerpt: string;
  content: string;
  image: string;
  author: string;
  date: string;
  views: number;
  tags: string[];
  rating: number;
}

export const articles: Article[] = [
  {
    id: '1',
    title: '《人世间》：一部关于普通人的史诗级家庭伦理剧',
    slug: 'ren-shi-jian-jia-ting-lun-li-ju',
    category: 'jiating-lunli',
    excerpt: '《人世间》以周家三代人的命运变迁为主线，横跨五十年的时代洪流，深刻描绘了中国普通家庭在巨变中的坚守与温情。这是一部关于父母、子女、兄弟姐妹之间最真挚情感的诗篇。',
    content: `<p>《人世间》改编自梁晓声同名小说，以北方某省会城市"光字片"的周家为核心，讲述了从上世纪六十年代末到新世纪，周家三代人在时代变迁中的命运沉浮。</p>
<h3>剧情概述</h3>
<p>周家父亲周志刚是新中国第一代建筑工人，参与了大西南三线建设。母亲李素华独自抚养三个孩子：长子周秉义、女儿周蓉、小儿子周秉昆。故事以周秉昆的视角展开，他留在了父母身边，承担起照顾家庭的责任，经历了工厂改制、下岗潮、改革开放等重大历史事件。</p>
<h3>情感内核</h3>
<p>这部剧最动人的地方在于它展现了家庭伦理中最本真的情感——父母对子女无私的爱、兄弟姐妹间血浓于水的羁绊、夫妻在困境中的相濡以沫。周秉昆与妻子郑娟的爱情，从最初的怜悯到后来的生死相依，诠释了"执子之手，与子偕老"的真谛。</p>
<h3>推荐理由</h3>
<p>《人世间》以极其真实细腻的笔触描绘了中国百姓的生活图景，剧中每一个人物都饱满立体，每一个故事都引人深思。它不仅是一部家庭剧，更是一部时代剧，让我们在感动中回望历史，在泪水中感悟人生。</p>
<h3>经典台词</h3>
<p>"人这一辈子，你真的在意的，同时又在意你的，就那么几个人。这几个人，就是你的全部世界。"</p>`,
    image: 'https://readdy.ai/api/search-image?query=Warm%20Chinese%20family%20gathering%20in%20a%20cozy%20living%20room%2C%20multiple%20generations%20sitting%20together%2C%20soft%20golden%20light%20streaming%20through%20window%2C%20nostalgic%20retro%20Chinese%20home%20interior%2C%20emotional%20atmosphere%2C%20cinematic%20composition%2C%20warm%20amber%20tones%2C%20film%20grain%20texture%2C%20intimate%20family%20portrait%20moment&width=800&height=500&seq=article-1&orientation=landscape',
    author: '影评人·林晓',
    date: '2024-12-15',
    views: 128600,
    tags: ['家庭伦理', '国产经典', '年代剧', '豆瓣高分', '催泪'],
    rating: 9.4,
  },
  {
    id: '2',
    title: '《都挺好》：原生家庭之痛的深刻剖析',
    slug: 'dou-ting-hao-yuan-sheng-jia-ting',
    category: 'jiating-lunli',
    excerpt: '《都挺好》撕开了中国式家庭温情脉脉的面纱，直指重男轻女、啃老、赡养等敏感话题。苏明玉的成长故事让无数观众看到了自己的影子，引发了对原生家庭的深刻反思。',
    content: `<p>《都挺好》改编自阿耐同名小说，讲述了苏家三兄妹在母亲突然去世后，围绕父亲的赡养问题展开的一系列家庭矛盾与情感纠葛。</p>
<h3>剧情概述</h3>
<p>苏家有三个孩子：大哥苏明哲在美国工作生活，二哥苏明成在父母身边被宠坏，小妹苏明玉从小就因母亲的偏心而被忽视。母亲去世后，父亲苏大强的赡养问题成了引爆家庭矛盾的导火索。苏明玉虽然内心有伤，却成为最终扛起家庭责任的那个人。</p>
<h3>情感内核</h3>
<p>这部剧最扎心的部分在于它对原生家庭伤害的真实呈现。苏明玉从小被母亲区别对待，这种伤害伴随她一生，却也在与家人的不断碰撞中获得了某种和解。剧中没有简单的善恶二分，每个人物都有其合理性和局限性。</p>
<h3>推荐理由</h3>
<p>《都挺好》之所以能引发全民讨论，是因为它触及了中国家庭中最真实、最普遍的痛处。它让我们思考：什么是真正的"都挺好"？是表面的和和气气，还是勇敢面对问题后的坦诚相待？</p>
<h3>经典台词</h3>
<p>"有些路，注定要一个人走。"</p>`,
    image: 'https://readdy.ai/api/search-image?query=Modern%20Chinese%20apartment%20interior%20with%20a%20woman%20sitting%20alone%20by%20the%20window%2C%20reflective%20mood%2C%20soft%20evening%20light%2C%20contemporary%20furniture%2C%20emotional%20solitude%2C%20warm%20but%20melancholic%20atmosphere%2C%20cinematic%20lighting%2C%20subdued%20color%20palette%2C%20introspective%20portrait%20composition&width=800&height=500&seq=article-2&orientation=landscape',
    author: '剧评人·王思涵',
    date: '2024-11-28',
    views: 95300,
    tags: ['家庭伦理', '原生家庭', '社会话题', '豆瓣高分', '女性成长'],
    rating: 8.9,
  },
  {
    id: '3',
    title: '《请回答1988》：邻里温情的极致表达',
    slug: 'qing-hui-da-1988-lin-li-wen-qing',
    category: 'hanju-lunli',
    excerpt: '韩剧《请回答1988》以1988年首尔双门洞为背景，讲述了五个家庭之间超越血缘的深厚情谊。这部剧用最平凡的生活细节，写出了最不平凡的人间真情。',
    content: `<p>《请回答1988》是"请回答"系列的第三部，以1988年汉城奥运会为时代背景，聚焦首尔双门洞胡同里五个家庭的生活日常。</p>
<h3>剧情概述</h3>
<p>双门洞住着五户人家：成德善一家、金正焕一家、成善宇一家、崔泽一家和刘东龙一家。五个家庭的孩子是青梅竹马，大人们则是互帮互助的邻里。故事围绕孩子们的青春成长和大人们的生活百态展开，每一集都充满了笑与泪。</p>
<h3>情感内核</h3>
<p>这部剧最了不起的地方在于它对"邻里关系"的极致描绘。在双门洞，邻居不只是住在隔壁的人，而是可以在深夜送一碗热汤、在困难时伸出援手、在喜悦时一起分享的家人。这种超越血缘的情感，在当今社会愈发珍贵。</p>
<h3>推荐理由</h3>
<p>《请回答1988》是那种看完会让你想给父母打电话、想跟老朋友聚一聚的剧。它提醒我们，在追逐梦想的路上，别忘了身后那些默默支持你的人。每一集都是一封写给过去的情书。</p>
<h3>经典台词</h3>
<p>"听说神不能无处不在，所以创造了妈妈。"</p>`,
    image: 'https://readdy.ai/api/search-image?query=Nostalgic%201980s%20Korean%20neighborhood%20alley%20with%20warm%20street%20lights%2C%20friends%20gathering%20on%20steps%2C%20retro%20clothing%20style%2C%20autumn%20leaves%2C%20golden%20hour%20sunset%20lighting%2C%20heartwarming%20community%20atmosphere%2C%20film%20photography%20aesthetic%2C%20small%20town%20charm&width=800&height=500&seq=article-3&orientation=landscape',
    author: '韩剧评论人·赵雅琳',
    date: '2024-12-08',
    views: 156200,
    tags: ['韩剧伦理', '邻里温情', '青春怀旧', '豆瓣高分', '催泪神剧'],
    rating: 9.7,
  },
  {
    id: '4',
    title: '《我的前半生》：婚姻伦理与女性独立的觉醒之路',
    slug: 'wo-de-qian-ban-sheng-hun-yin-lun-li',
    category: 'aiqing-lunli',
    excerpt: '《我的前半生》讲述了全职太太罗子君遭遇婚姻危机后，在闺蜜唐晶和其男友贺涵的帮助下重新站起来的故事。这部剧引发了关于婚姻、友情与独立的热烈讨论。',
    content: `<p>《我的前半生》改编自亦舒同名小说，将故事背景从香港搬到了当代上海，讲述了全职太太罗子君在婚姻破裂后如何重新找回自我的故事。</p>
<h3>剧情概述</h3>
<p>罗子君大学毕业后直接结婚，做了十几年的全职太太，生活优渥但与社会脱节。丈夫陈俊生出轨后提出离婚，罗子君的世界一夜崩塌。在闺蜜唐晶的帮助和其男友贺涵的刺激下，罗子君从零开始学习独立生活，最终在职场上找到了自己的价值。</p>
<h3>情感内核</h3>
<p>这部剧最大的争议点在于罗子君与贺涵之间的感情线——她爱上了帮助自己走出低谷的闺蜜的男友。这种情感纠葛引发了关于"恩情"与"爱情"边界的大讨论。同时，罗子君的成长故事也给无数女性以启发。</p>
<h3>推荐理由</h3>
<p>《我的前半生》让我们看到，婚姻不是人生的全部，女性的价值不应该由婚姻来定义。无论处于人生的哪个阶段，都要保持独立的能力和重新开始的勇气。</p>
<h3>经典台词</h3>
<p>"没有任何人会成为你以为的今生今世的避风港，只有你自己才是自己最后的庇护所。"</p>`,
    image: 'https://readdy.ai/api/search-image?query=Elegant%20Chinese%20woman%20in%20modern%20Shanghai%20office%2C%20professional%20attire%2C%20looking%20confident%20and%20independent%2C%20floor%20to%20ceiling%20windows%20with%20city%20skyline%20view%2C%20warm%20sunset%20lighting%2C%20empowered%20female%20portrait%2C%20contemporary%20corporate%20setting%2C%20inspirational%20atmosphere&width=800&height=500&seq=article-4&orientation=landscape',
    author: '影评人·刘芳',
    date: '2024-10-20',
    views: 87200,
    tags: ['爱情伦理', '女性独立', '婚姻话题', '都市情感', '亦舒改编'],
    rating: 8.5,
  },
  {
    id: '5',
    title: '《小欢喜》：高考压力下的家庭教育伦理',
    slug: 'xiao-huan-xi-gao-kao-jia-ting-jiao-yu',
    category: 'shehui-lunli',
    excerpt: '《小欢喜》以三个高考家庭为核心，真实呈现了中国式教育焦虑。当父母的期望与孩子的梦想产生碰撞，家庭伦理中的爱与控制成为最值得深思的话题。',
    content: `<p>《小欢喜》是"小"系列的第二部，以北京三个家庭的孩子备战高考为主线，展现了当代中产阶级家庭在教育问题上的焦虑、冲突与和解。</p>
<h3>剧情概述</h3>
<p>方圆和童文洁的儿子方一凡是个活泼开朗但成绩一般的孩子；乔卫东和宋倩的女儿乔英子是学霸但承受着巨大的心理压力；季胜利和刘静的儿子季杨杨因为父母长期在外工作而关系疏离。三个家庭围绕高三这一年的生活，展开了关于教育方式、亲子关系和家庭价值的深刻讨论。</p>
<h3>情感内核</h3>
<p>这部剧最动人的地方在于它让观众看到：父母的爱有时候会变成一种无形的压力。宋倩对英子的"为你好"式的控制，是多少中国家庭的真实写照？而当英子患上抑郁症时，所有人才意识到，没有什么比孩子的身心健康更重要。</p>
<h3>推荐理由</h3>
<p>《小欢喜》用温暖而克制的方式探讨了中国家庭教育的困局。它告诉所有家长：孩子不是父母未完成梦想的延续，每个生命都值得被尊重和倾听。</p>
<h3>经典台词</h3>
<p>"人生就是一场场小别离和一次次小欢喜组成的。"</p>`,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20high%20school%20students%20studying%20at%20desks%20in%20classroom%2C%20warm%20sunlight%20through%20windows%2C%20books%20and%20papers%20scattered%2C%20focused%20expressions%2C%20realistic%20school%20life%20scene%2C%20hopeful%20yet%20stressful%20atmosphere%2C%20educational%20setting%2C%20teenage%20life%20portrait&width=800&height=500&seq=article-5&orientation=landscape',
    author: '教育评论员·张明',
    date: '2024-11-10',
    views: 102400,
    tags: ['社会伦理', '教育话题', '高考', '亲子关系', '现实主义'],
    rating: 9.1,
  },
  {
    id: '6',
    title: '《父母爱情》：半个世纪的相濡以沫',
    slug: 'fu-mu-ai-qing-ban-shi-ji-xiang-ru-yi-mo',
    category: 'jingdian-lunli',
    excerpt: '《父母爱情》讲述了海军军官江德福与资本家小姐安杰跨越身份差异、携手走过五十年的爱情故事。在磕磕绊绊中，他们用一生诠释了什么是真正的白头偕老。',
    content: `<p>《父母爱情》以倒叙和插叙的手法，讲述了江德福和安杰从相识、相爱到相守一生的故事。时间跨度从二十世纪五十年代一直到新世纪，是一部跨越半个世纪的爱情史诗。</p>
<h3>剧情概述</h3>
<p>海军军官江德福出身贫苦，为人憨厚老实；安杰是资本家的女儿，知书达理，在那个特殊年代身份敏感。两人在舞会上相识，江德福对安杰一见钟情，不顾她的家庭背景执意追求。婚后两人搬到海岛生活，经历了物资匮乏的困难时期、政治运动的风波，以及抚养五个孩子的艰辛。</p>
<h3>情感内核</h3>
<p>这部剧最感人的地方在于它展现了爱情在日常生活中的样貌——不是轰轰烈烈的浪漫，而是柴米油盐中的坚守。江德福和安杰性格迥异，生活中磕磕绊绊不断，但每一次矛盾过后，两人的感情反而更深。他们的爱情，是岁月沉淀后的醇香。</p>
<h3>推荐理由</h3>
<p>《父母爱情》没有狗血的剧情和刻意的煽情，却让无数观众从头哭到尾。它告诉我们：真正的爱情不是找到一个完美的人，而是找到一个愿意跟你一起变老的人。</p>
<h3>经典台词</h3>
<p>"我这辈子做过最正确的事情，就是娶了你。"</p>`,
    image: 'https://readdy.ai/api/search-image?query=Elderly%20Chinese%20couple%20walking%20hand%20in%20hand%20on%20a%20peaceful%20seaside%20path%20at%20sunset%2C%20silver%20hair%2C%20gentle%20smiles%2C%20retro%20clothing%20style%2C%20nostalgic%20atmosphere%2C%20golden%20warm%20lighting%2C%20lifetime%20love%20portrait%2C%20romantic%20old%20age%2C%20timeless%20affection&width=800&height=500&seq=article-6&orientation=landscape',
    author: '资深影评人·陈志远',
    date: '2024-09-15',
    views: 189300,
    tags: ['经典伦理', '父母爱情', '年代剧', '豆瓣高分', '催泪'],
    rating: 9.6,
  },
  {
    id: '7',
    title: '《乔家的儿女》：五个孩子的成长史诗',
    slug: 'qiao-jia-de-er-nv-cheng-zhang-shi-shi',
    category: 'guochan-lunli',
    excerpt: '《乔家的儿女》讲述了乔家五个孩子在母亲去世、父亲不靠谱的情况下相互扶持长大的故事。这是一部关于手足情深的温暖之作，展现了底层家庭的生命韧性。',
    content: `<p>《乔家的儿女》改编自未夕同名小说，以南京为背景，讲述了乔家五个孩子——乔一成、乔二强、乔三丽、乔四美、乔七七从童年到中年的成长历程。</p>
<h3>剧情概述</h3>
<p>乔家母亲在生下小儿子七七后去世，父亲乔祖望是个自私又不靠谱的人，大哥乔一成才十几岁就扛起了照顾弟弟妹妹的重担。五个孩子在困苦中相互扶持，各自经历了爱情的甜蜜与苦涩、事业的起起落落，但无论遇到什么困难，他们始终是最坚实的依靠。</p>
<h3>情感内核</h3>
<p>这部剧的核心是"手足之情"。在那个物质匮乏的年代，一块糖分五份、一件衣服轮流穿，这些细节构成了最真挚的兄妹情谊。大哥乔一成更是用自己的一生诠释了什么叫"长兄如父"。</p>
<h3>推荐理由</h3>
<p>《乔家的儿女》的叙事节奏沉稳有力，人物塑造饱满真实。它让我们看到，即使生活艰难，只要有家人在身边，就没有过不去的坎。这部剧是对亲情最朴素也最动人的歌颂。</p>
<h3>经典台词</h3>
<p>"我们是一家人，一家人就要在一起。"</p>`,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20siblings%20gathered%20in%20a%20modest%20traditional%20home%20in%20Nanjing%2C%20five%20people%20of%20different%20ages%2C%20worn%20but%20clean%20clothing%2C%20warm%20unity%20despite%20poverty%2C%20nostalgic%201980s%20China%20interior%2C%20afternoon%20light%2C%20documentary%20style%20realism%2C%20heartwarming%20family%20bond&width=800&height=500&seq=article-7&orientation=landscape',
    author: '剧评人·孙悦',
    date: '2024-08-22',
    views: 76500,
    tags: ['国产伦理', '手足情深', '年代剧', '南京故事', '成长'],
    rating: 8.7,
  },
  {
    id: '8',
    title: '《天空之城》：韩国上流社会的教育伦理',
    slug: 'tian-kong-zhi-cheng-jiao-yu-lun-li',
    category: 'hanju-lunli',
    excerpt: '《天空之城》以韩国顶级精英社区为背景，揭露了上流社会家庭在子女教育上的扭曲与疯狂。这部剧以黑色幽默的手法，对教育体制和阶层焦虑进行了犀利的批判。',
    content: `<p>《天空之城》是韩国JTBC电视台的爆款剧集，以虚构的高级住宅区"天空之城"为舞台，讲述了四个韩国上流社会家庭的子女教育战争。</p>
<h3>剧情概述</h3>
<p>天空之城的居民都是韩国顶尖的医生、教授等精英阶层。为了让子女考入首尔大学医学院，家长们不惜投入天价费用聘请高考协调员——一种专门为学生安排所有学习计划的"升学军师"。剧集围绕四个家庭的教育竞争展开，随着一位母亲的自杀，隐藏在这片光鲜社区背后的黑暗秘密逐渐浮出水面。</p>
<h3>情感内核</h3>
<p>这部剧最震撼的地方在于它对"以爱之名行控制之实"的批判。家长们声称一切都是为了孩子好，但实际上他们是在用孩子的成就来满足自己的虚荣心。当这种扭曲的"爱"将孩子逼向绝路时，所有人才幡然醒悟。</p>
<h3>推荐理由</h3>
<p>《天空之城》虽然背景在韩国，但其中的教育焦虑、阶层固化等问题具有普遍性，中国观众同样能从中看到自己的影子。它是一部让人笑中带泪、看完后久久不能平静的神作。</p>
<h3>经典台词</h3>
<p>"你所谓的为了孩子好，不过是为了你自己。"</p>`,
    image: 'https://readdy.ai/api/search-image?query=Luxurious%20modern%20Korean%20mansion%20exterior%20in%20upscale%20neighborhood%2C%20perfect%20green%20lawns%2C%20cold%20and%20sterile%20atmosphere%2C%20wealthy%20residential%20area%2C%20dark%20undercurrent%20beneath%20perfect%20surface%2C%20architectural%20photography%2C%20moody%20overcast%20lighting%2C%20social%20satire%20visual&width=800&height=500&seq=article-8&orientation=landscape',
    author: '韩剧评论人·金美英',
    date: '2024-11-05',
    views: 113800,
    tags: ['韩剧伦理', '教育话题', '黑色幽默', '社会批判', '爆款韩剧'],
    rating: 9.3,
  },
  {
    id: '9',
    title: '《蜗居》：都市生存困境中的伦理抉择',
    slug: 'wo-ju-du-shi-sheng-cun-lun-li',
    category: 'shehui-lunli',
    excerpt: '《蜗居》以房价飞涨的上海为背景，讲述了两姐妹在都市生存压力下做出的不同选择。这部剧因其对社会现实的犀利呈现而成为现象级作品，至今仍有强烈的现实意义。',
    content: `<p>《蜗居》是六六编剧的经典作品，以2009年的上海为背景，通过郭海萍和郭海藻两姐妹的不同人生轨迹，揭示了都市普通人在高房价压力下的生存困境与伦理抉择。</p>
<h3>剧情概述</h3>
<p>姐姐郭海萍和丈夫苏淳为了在上海买房省吃俭用，蜗居在十几平米的小房子里；妹妹郭海藻大学毕业后与男友小贝甜蜜同居。在一次偶然的机会中，海藻结识了有权有势的市长秘书宋思明，陷入了金钱与情感的漩涡。两个家庭的故事交织在一起，展现了都市小人物在现实压力下的挣扎。</p>
<h3>情感内核</h3>
<p>《蜗居》最引人深思的地方在于它提出的问题：当生存的压力大到让人喘不过气时，道德和底线还有意义吗？海藻的选择让人气愤也让人心疼，她不是天生的"小三"，而是被现实一步步推向了那条路。这部剧没有简单的道德审判，而是让我们看到了人性的复杂。</p>
<h3>推荐理由</h3>
<p>《蜗居》虽然播出于十多年前，但其中关于房价、职场、婚姻的讨论至今仍然尖锐。它是一部敢于直面社会现实的勇气之作，每个在大城市打拼的年轻人都能从中找到共鸣。</p>`,
    image: 'https://readdy.ai/api/search-image?query=Cramped%20small%20apartment%20in%20Shanghai%2C%20modern%20Chinese%20city%20view%20through%20tiny%20window%2C%20contrast%20between%20small%20living%20space%20and%20towering%20skyscrapers%20outside%2C%20evening%20city%20lights%2C%20social%20realism%2C%20urban%20struggle%20aesthetic%2C%20thoughtful%20atmosphere&width=800&height=500&seq=article-9&orientation=landscape',
    author: '社会评论员·周明',
    date: '2024-10-08',
    views: 145600,
    tags: ['社会伦理', '房价话题', '都市生存', '现实题材', '经典回顾'],
    rating: 8.8,
  },
  {
    id: '10',
    title: '《媳妇的美好时代》：婆媳关系的温暖化解',
    slug: 'xi-fu-de-mei-hao-shi-dai-po-xi-guan-xi',
    category: 'guochan-lunli',
    excerpt: '《媳妇的美好时代》以轻松幽默的方式讲述了一个现代媳妇如何巧妙化解婆媳矛盾的故事。这部剧打破了婆媳剧"苦情"的刻板印象，用温暖和智慧展现了家庭关系的另一种可能。',
    content: `<p>《媳妇的美好时代》由海清、黄海波主演，讲述了心理咨询师毛豆豆在嫁给摄影师余味后，如何用智慧和爱心处理复杂的家庭关系的故事。</p>
<h3>剧情概述</h3>
<p>毛豆豆是个乐观开朗的心理咨询师，嫁给余味后不仅要面对一个挑剔的婆婆，还有一个难缠的小姑子。更复杂的是，余味的父母离婚后又各自再婚，这意味着毛豆豆有两个婆婆需要应对。但毛豆豆凭借自己的专业知识和善良本性，一步步化解了家庭中的各种矛盾。</p>
<h3>情感内核</h3>
<p>这部剧最难得的地方在于它提供了处理家庭矛盾的正向示范。毛豆豆面对婆媳问题时，不是一味忍让也不是针锋相对，而是用沟通和理解来化解隔阂。这种智慧，让这部剧成为了一部"婆媳关系教科书"。</p>
<h3>推荐理由</h3>
<p>如果你看腻了那些鸡飞狗跳的家庭剧，《媳妇的美好时代》会给你带来一股清流。它温暖、好笑又治愈，让人相信婆媳之间也可以有美好的关系。</p>`,
    image: 'https://readdy.ai/api/search-image?query=Warm%20Chinese%20kitchen%20scene%2C%20young%20woman%20and%20older%20woman%20cooking%20together%20happily%2C%20smiles%20and%20laughter%2C%20modern%20Chinese%20home%20interior%2C%20afternoon%20sunlight%2C%20harmonious%20mother%20in%20law%20and%20daughter%20in%20law%20relationship%2C%20cozy%20family%20moment%2C%20feel-good%20atmosphere&width=800&height=500&seq=article-10&orientation=landscape',
    author: '家庭专栏作者·吴敏',
    date: '2024-09-30',
    views: 68400,
    tags: ['国产伦理', '婆媳关系', '轻松喜剧', '家庭和谐', '温暖治愈'],
    rating: 8.3,
  },
  {
    id: '11',
    title: '《大江大河》：改革开放浪潮中的个体命运与家庭伦理',
    slug: 'da-jiang-da-he-gai-ge-kai-fang-lun-li',
    category: 'guochan-lunli',
    excerpt: '《大江大河》以改革开放四十年为背景，通过宋运辉、雷东宝、杨巡三个不同出身的人物命运，展现了大时代中小人物的奋斗与选择，以及他们在家庭与事业间的伦理权衡。',
    content: `<p>《大江大河》改编自阿耐小说《大江东去》，是近年来最具分量的现实主义力作之一。它以1978年至1992年的改革开放初期为背景，通过三种不同的人生轨迹，展现了那个激情燃烧的年代里，个体如何在时代洪流中寻找自己的位置。</p>
<h3>剧情概述</h3>
<p>宋运辉出身农村，凭借知识改变命运，成为国企技术骨干；雷东宝是退伍军人，带领小雷家村走上集体致富之路；杨巡从个体户起家，在市场经济的浪潮中沉浮。三个人的故事交织在一起，构成了一幅波澜壮阔的时代画卷。</p>
<h3>情感内核</h3>
<p>在宏大的时代背景下，《大江大河》始终没有忘记对家庭伦理的刻画。宋运辉与姐姐宋运萍的深厚感情、雷东宝对妻子的深情与愧疚、杨巡对母亲的孝顺——这些情感细节让宏大的叙事有了温度。</p>
<h3>推荐理由</h3>
<p>《大江大河》最珍贵的品质是它的"真实"。剧中没有一个完美的人物，每个人都有自己的局限和挣扎，但正是这种不完美让他们更加可信。如果你想了解中国改革开放的历程，这部剧是最好的窗口。</p>`,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20factory%20workers%20in%201980s%20industrial%20setting%2C%20amber%20nostalgic%20lighting%2C%20steel%20machinery%20and%20hardworking%20people%2C%20reform%20and%20opening%20up%20era%20aesthetic%2C%20vintage%20Chinese%20industry%2C%20hopeful%20determination%2C%20epic%20narrative%20tone%2C%20warm%20sepia%20color%20palette&width=800&height=500&seq=article-11&orientation=landscape',
    author: '历史评论员·郑重',
    date: '2024-08-18',
    views: 134200,
    tags: ['国产伦理', '改革开放', '时代剧', '现实主义', '豆瓣高分'],
    rating: 9.5,
  },
  {
    id: '12',
    title: '《如父如子》：血缘与养育之恩的伦理困境',
    slug: 'ru-fu-ru-zi-xue-yuan-yang-yu-lun-li',
    category: 'jingdian-lunli',
    excerpt: '是枝裕和的《如父如子》讲述了一个抱错孩子的故事，两个家庭面临着一个残酷的选择：是换回自己的亲生骨肉，还是留下养育了六年的孩子？这部电影对"何为父亲"进行了深刻的伦理追问。',
    content: `<p>《如父如子》是日本导演是枝裕和的经典作品，获得第66届戛纳电影节评审团奖。影片通过一个"抱错孩子"的极端事件，探讨了血缘关系与养育之恩孰轻孰重的伦理命题。</p>
<h3>剧情概述</h3>
<p>野野宫良多是一个事业有成的建筑师，与妻子和六岁的儿子庆多过着优渥的生活。一天，医院打来电话，告知庆多并非他们的亲生孩子——六年前在医院被抱错了。另一个家庭斋木家经营着一家小电器店，生活拮据但温馨和睦。两个家庭面临着一个艰难的抉择。</p>
<h3>情感内核</h3>
<p>这部电影最深刻的地方在于它对"父亲"这一角色的重新定义。良多一直认为做一个好父亲就是提供优越的物质条件，但在与斋木家的接触中，他逐渐意识到陪伴和爱才是为人父母的核心。血缘重要，但六年的朝夕相处更重要。</p>
<h3>推荐理由</h3>
<p>是枝裕和的电影有一种独特的温柔和克制，从不煽情却总是让人泪流满面。《如父如子》用平静的叙事探讨了一个残酷的问题，让每个观众都忍不住问自己：如果是你，你会怎么选？</p>`,
    image: 'https://readdy.ai/api/search-image?query=Japanese%20father%20and%20young%20son%20playing%20in%20a%20park%20at%20sunset%2C%20gentle%20golden%20light%2C%20autumn%20leaves%2C%20peaceful%20residential%20neighborhood%2C%20poignant%20parenting%20moment%2C%20Japanese%20cinema%20aesthetic%2C%20quiet%20emotional%20depth%2C%20thoughtful%20composition&width=800&height=500&seq=article-12&orientation=landscape',
    author: '电影评论人·林雅文',
    date: '2024-07-25',
    views: 91200,
    tags: ['经典伦理', '日本电影', '是枝裕和', '父子关系', '戛纳获奖'],
    rating: 9.2,
  },
];